import s from "./TourYoutubeEmbed.module.scss";

const getYoutubeEmbedUrl = (url) => {
  if (!url || typeof url !== "string") return "";

  try {
    const parsed = new URL(url);
    const host = parsed.hostname.replace("www.", "");

    if (host === "youtu.be") {
      const id = parsed.pathname.replace("/", "");
      return id ? `https://www.youtube.com/embed/${id}` : "";
    }

    if (host === "youtube.com" || host === "m.youtube.com") {
      if (parsed.pathname.startsWith("/shorts/")) {
        const id = parsed.pathname.split("/")[2];
        return id ? `https://www.youtube.com/embed/${id}` : "";
      }

      if (parsed.pathname.startsWith("/embed/")) {
        return url;
      }

      const id = parsed.searchParams.get("v");
      return id ? `https://www.youtube.com/embed/${id}` : "";
    }
  } catch {
    return "";
  }

  return "";
};

const TourYoutubeEmbed = ({ url, title = "Tour video", isCompact = false }) => {
  const embedUrl = getYoutubeEmbedUrl(url);

  if (!embedUrl) return null;

  return (
    <section className={`${s.root} ${isCompact ? s.compact : ""}`}>
      <div className={s.card}>
        <div className={s.heading}>
          <span>Movie</span>
          <p>ツアーの雰囲気を動画で見る</p>
        </div>

        <div className={s.frame}>
          <iframe
            src={embedUrl}
            title={title}
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
};

export default TourYoutubeEmbed;
